import * as React from 'react'

import {
  Box,
  Checkbox,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import { AddonSelected } from 'modules/billing/components/PricingBox/types'
import { NormalPlan } from 'modules/billing/lib/prices'
import { companyMainLocation } from 'modules/locations/store/collections/locations'

type Props = {
  currency: string
  availableAddons: NormalPlan[] | undefined
  addonsSelected: AddonSelected[]
  setAddonsSelected: React.Dispatch<React.SetStateAction<AddonSelected[]>>
}

const CheckboxTooltip = ({ label }: { label: string }) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box alignSelf="center">
      <Tooltip.Alt size="big" attachment="bottom center" open={open} toggle={toggle} label={label}>
        <Icon.Medium icon="info-circle-line" color="grey800" />
      </Tooltip.Alt>
    </Box>
  )
}

const ExtraAddons = ({ availableAddons, addonsSelected, setAddonsSelected, currency }: Props) => {
  const isoCode = legalEntities.main ? legalEntities.main.country : companyMainLocation().country

  return (
    <Box paddingX="s24" paddingY="s32" gap="s16" alignSelf="start">
      <Text size="300" color="grey800" weight="semibold">
        {i18n.t('pricing_plans.hubs.addons.title')}:
      </Text>
      {!!availableAddons?.length &&
        availableAddons.map((addon) => {
          const internalTitle = addon.internalTitle
          const parentModule = addon.parentModule

          return (
            <Box key={internalTitle} flexDirection="row" gap="s8">
              <Checkbox
                checked={addonsSelected.some(
                  (selAddon) => selAddon.internalTitle === internalTitle
                )}
                onChange={(event) => {
                  if (event.target.checked) {
                    setAddonsSelected((prevAddons) => [
                      ...prevAddons,
                      { internalTitle, parentModule },
                    ])
                  } else {
                    setAddonsSelected(
                      addonsSelected.filter((e) => e.internalTitle !== internalTitle)
                    )
                  }
                }}
                label={addon.title}
              />
              {addon.description && <CheckboxTooltip label={addon.description} />}
            </Box>
          )
        })}
    </Box>
  )
}

export default ExtraAddons
